import React from 'react';
import { CancelIcon, EditIcon, SaveIcon } from './IconButtons';
import InputField from './InputField';
import IndustryModal from '../Registration/CompanyRegistration/IndustryModal';
import { countryPhoneCode, industryOptions } from '../Constants/constant';
import Dropdown from './Dropdown';
import CloseModal from './CloseModal';
import CountryCodeDropdown from './CountryCodeDropdown';

const CompanyRegistration = ({data, errors, OnlyView, loading, disabled,
    onChange, onEdit, onCancel, onSubmit, onClose
}) => {
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-5 rounded-2xl '>
                {!OnlyView && 
                    (data?.id && onEdit && disabled ? 
                    <EditIcon disabled={loading} className=" top-3 left-8" onClick={onEdit} /> :
                    <>
                        {data?.id && <CancelIcon disabled={loading} className=" top-3 left-8" onClick={onCancel} />}
                        <SaveIcon disabled={loading} loading={loading} className={`${data?.id ? "top-3 left-36" : "top-3 left-3"}`} onClick={onSubmit} />
                    </>)
                }
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Compnay Registration</h1>
                <form className='text-left flex flex-col gap-x-4 gap-y-3 px-2 max-h-[70vh] overflow-y-scroll'>
                    <div id='page1' className=' relative flex flex-col gap-5 h-fit bg-white grayBlurShadow rounded-xl py-4 px-2 '>
                        <div className='relative flex flex-col gap-5 p-7 borderDarkBlue rounded-3xl'>
                            <h1 className=' bg-white absolute top-15px font-semibold px-1 textDarkBlue'>Company Details</h1>
                            <div className='grid grid-cols-2 gap-3'>
                                <InputField
                                    id="company_name"
                                    name="company_name"
                                    label="Name:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Name`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.company_name}
                                    error={errors?.company_name}
                                    onChange={onChange}
                                    required={true}
                                />
                                <Dropdown 
                                    id="industry" 
                                    name="industry"
                                    label="Industry:"
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled}
                                    placeholder={`Industry`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.industry}
                                    error={errors?.industry}
                                    options={industryOptions}
                                    required={true}
                                />
                            </div>
                            <div>
                                <h2 className={`block text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Summary
                                    <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                        <span className=" absolute top-[-2px] left-[3px]">*</span>
                                    </span>
                                </h2>
                                <textarea name="summary" id="summary" rows="5"
                                className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                                disabled={disabled} placeholder="Enter Summary..." onChange={onChange}
                                >{data?.summary}
                                </textarea>
                            </div>
                            <div>
                                <h2 className={`block text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Address
                                    <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                        <span className=" absolute top-[-2px] left-[3px]">*</span>
                                    </span>
                                </h2>
                                <textarea name="address" id="address" rows="5"
                                className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                                disabled={disabled} placeholder="Enter Address..." onChange={onChange}
                                >{data?.address}
                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div id='page2' className=' relative flex flex-col gap-5  bg-white navAnimation grayBlurShadow rounded-xl py-4 px-2 '>

                        <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Contact Persons Details</h1>
                        <div className=' relative flex flex-col gap-2 p-7 borderDarkBlue rounded-3xl'>
                            <h1 className=' bg-white absolute top-15px font-semibold px-1 textDarkBlue'>Person 1 Details</h1>
                            <div className='grid grid-cols-2 gap-3'>
                                <InputField
                                    id="poc1_name"
                                    name="poc1_name"
                                    label="Name:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Name`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.poc1_name}
                                    error={errors?.poc1_name}
                                    onChange={onChange}
                                    required={true}
                                />
                                <InputField
                                    id="poc1_designation"
                                    name="poc1_designation"
                                    label="Designation:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Designation`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.poc1_designation}
                                    error={errors?.poc1_designation}
                                    onChange={onChange}
                                    required={true}
                                />
                                <div>
                                    <h2 className={`flex text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Mobile:
                                        <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                            <span className=" absolute top-[-2px] left-[3px]">*</span>
                                        </span>
                                    </h2>
                                    <div className="flex items-start gap-2">
                                        <CountryCodeDropdown id="poc1_phone_code" name="poc1_phone_code"
                                            onChange={onChange}
                                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                            disabled={disabled}
                                            placeholder={`Country Code`}
                                            textColor={disabled && "text-blue-700"}
                                            value={data?.poc1_phone_code}
                                            error={errors?.poc1_phone_code}
                                            options={countryPhoneCode}
                                        />
                                        <InputField
                                            id="poc1_phone"
                                            name="poc1_phone"
                                            type="text"
                                            disabled={disabled}
                                            placeholder={`Enter Mobile Number`}
                                            textColor={disabled && "text-blue-700"}
                                            className="flex-1"
                                            value={data?.poc1_phone}
                                            error={errors?.poc1_phone}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <InputField
                                    id="poc1_email"
                                    name="poc1_email"
                                    label="Email:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Email`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.poc1_email}
                                    error={errors?.poc1_email}
                                    onChange={onChange}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className=' relative flex flex-col gap-2 p-7 borderDarkBlue rounded-3xl'>
                            <h1 className=' bg-white absolute top-15px font-semibold px-1 textDarkBlue'>Person 2 Details</h1>
                            <div className=' grid grid-cols-2 gap-3'>
                                <InputField
                                    id="poc2_name"
                                    name="poc2_name"
                                    label="Name:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Name`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.poc2_name}
                                    error={errors?.poc2_name}
                                    onChange={onChange}
                                />
                                <InputField
                                    id="poc2_designation"
                                    name="poc2_designation"
                                    label="Designation:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Designation`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.poc2_designation}
                                    error={errors?.poc2_designation}
                                    onChange={onChange}
                                />
                                <div>
                                    <h2 className={`flex text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Mobile:</h2>
                                    <div className="flex items-start gap-2">
                                        <CountryCodeDropdown id="poc2_phone_code" name="poc2_phone_code"
                                            onChange={onChange}
                                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                            disabled={disabled}
                                            placeholder={`Country Code`}
                                            textColor={disabled && "text-blue-700"}
                                            value={data?.poc2_phone_code}
                                            error={errors?.poc2_phone_code}
                                            options={countryPhoneCode}
                                        />
                                        <InputField
                                            id="poc2_phone"
                                            name="poc2_phone"
                                            type="text"
                                            disabled={disabled}
                                            placeholder={`Enter Mobile Number*`}
                                            textColor={disabled && "text-blue-700"}
                                            className="flex-1"
                                            value={data?.poc2_phone}
                                            error={errors?.poc2_phone}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <InputField
                                    id="poc2_email"
                                    name="poc2_email"
                                    label="Email:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Email`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.poc2_email}
                                    error={errors?.poc2_email}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div id='page3' className=' relative flex flex-col gap-8  bg-white navAnimation grayBlurShadow rounded-xl py-4 px-2 '>
                        <div className=' relative flex flex-col gap-5 p-7 borderDarkBlue rounded-3xl'>
                            <h1 className=' bg-white absolute top-15px font-semibold px-1 textDarkBlue'>Credentials</h1>
                            <div className=' grid grid-cols-2 gap-3'>
                                <InputField
                                    id="company_username"
                                    name="company_username"
                                    label="Username:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Username`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.company_username}
                                    error={errors?.company_username}
                                    onChange={onChange}
                                    required={true}
                                />
                                <InputField
                                    id="company_password"
                                    name="company_password"
                                    label="Password:"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Password`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.company_password}
                                    error={errors?.company_password}
                                    onChange={onChange}
                                    required={true}
                                />
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
}

export default CompanyRegistration;
